var map = {
	"./about/about.module": [
		"./src/app/about/about.module.ts",
		"about-about-module~contact-contact-module~index-index-module",
		"about-about-module"
	],
	"./contact/contact.module": [
		"./src/app/contact/contact.module.ts",
		"about-about-module~contact-contact-module~index-index-module",
		"contact-contact-module"
	],
	"./index/index.module": [
		"./src/app/index/index.module.ts",
		"about-about-module~contact-contact-module~index-index-module",
		"index-index-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;